import { Directive, ElementRef, HostListener, inject, Input } from '@angular/core';

@Directive({
  selector: '[preventMultiClick]',
  standalone: true
})
export class PreventMultiClickDirective {
  @Input('preventMultiClick') set delayInput(value: number | string | undefined) {
    const parsed: number = Number(value);
    this.delay = !isNaN(parsed) && parsed > 0 ? parsed : 2000;
  }

  private delay: number = 2000;
  private isDisabled: boolean = false;

  private el: ElementRef<HTMLButtonElement> = inject(ElementRef<HTMLButtonElement>);

  @HostListener('click', ['$event'])
  handleClick(event: Event): void {
    if (this.isDisabled) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return;
    }

    this.disableTemporarily();
  }

  private disableTemporarily(): void {
    const button: HTMLButtonElement = this.el.nativeElement;
    this.isDisabled = true;
    button.disabled = true;

    setTimeout(() => {
      this.isDisabled = false;
      button.disabled = false;
    }, this.delay);
  }
}
